<template>
  <div class="purchase">
    <div class="purchase-container">
      <div class="top-container">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
          label-width="100px"
        >
          <div class="row">
            <el-form-item label="任务名称：" prop="taskName" >
              <el-input class="gray white w200" placeholder="请输入" v-model="ruleForm.taskName"></el-input>
            </el-form-item>
            <el-form-item label="发布时间：" prop="date">
              <el-date-picker
                v-model="ruleForm.date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                class="white w240"
                clearable>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态：" prop="status">
              <el-select
                v-model="ruleForm.status"
                placeholder="请选择"
                class="w200"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="执行人：" prop="executor">
              <el-input class="gray white w200" placeholder="请输入" v-model="ruleForm.executor"></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
              <el-button class="btn-blue" type="primary" @click="search">搜索</el-button>
              <el-button class="btn-blue" type="primary" @click="toRelease">任务发布</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="container">
        <div class="table" v-if="tableData.length > 0">
          <el-table
            :data="tableData"
          >
            <el-table-column label="任务名称" min-width="120">
              <template slot-scope="scope">
                <el-tooltip v-if="!isShowTableTooltip" class="item" effect="dark" placement="top-start">
                  <div slot="content">
                    <span v-for="(item, index) in scope.row.taskName" :key="index">
                      <span style="display:inline-block;">
                        {{item}}
                      </span>
                      <br v-if="(index+1)%20==0"/>
                    </span>
                  </div>
                  <div>
                    <span :ref="`refTaskTooltip${scope.$index}`" @mouseover="onMouseOverTable(`refTaskTooltip${scope.$index}`)">
                      {{scope.row.taskName}}
                    </span>
                  </div>
                </el-tooltip>
                <div v-else>
                  <span :ref="`refTaskTooltip${scope.$index}`" @mouseover="onMouseOverTable(`refTaskTooltip${scope.$index}`)">
                    {{scope.row.taskName}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="发布时间" width="150" prop="createTime"></el-table-column>
            <el-table-column label="执行人" min-width="250">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!isShowTooltip">
                  <div slot="content">
                    <span v-for="(item, index) in scope.row.executor" :key="index">
                      <span style="display:inline-block; margin: 0px 8px 4px 0px;">
                        {{item.name}}({{item.deptName}});
                      </span>
                      <br v-if="(index+1)%2==0"/>
                    </span>
                  </div>
                  <div :ref="`refExecutorTooltip${scope.$index}`" @mouseover="onMouseOver(`refExecutorTooltip${scope.$index}`, scope.row.executor.length, 'refExecutorTooltip')">
                    <span v-for="(item, index) in scope.row.executor" :key="index">
                      <span style="display:inline-block; background: #F5F6F7; border-radius: 12px; padding: 0px 8px; height: 22px;margin: 4px 4px 4px 0px;">
                        {{item.name}}({{item.deptName}});
                      </span>
                      <br v-if="(index+1)%2==0"/>
                    </span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="主要负责人" min-width="200" prop="director">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.director" :key="index">
                  <span style="display:inline-block; background: #F5F6F7; border-radius: 12px; padding: 0px 8px; height: 22px;margin: 4px 4px 4px 0px;">
                    {{item.name}}({{item.deptName}});
                  </span>
                  <br v-if="(index+1)%2==0"/>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="风险责任主体单位" min-width="350">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!isShowTooltip">
                  <div slot="content">
                    <span v-for="(item, index) in scope.row.riskCompany" :key="index">
                      <span style="display:inline-block; margin: 0px 8px 4px 0px;">
                        {{item.deptName}}({{item.name}});
                      </span>
                      <br v-if="(index+1)%2==0"/>
                    </span>
                  </div>
                  <div 
                  class="risk-company"
                  :ref="`refRiskCompanyrTooltip${scope.$index}`" 
                  @mouseover="onMouseOver(`refRiskCompanyrTooltip${scope.$index}`, scope.row.riskCompany.length, 'refRiskCompanyrTooltip', scope.row.riskCompany)">
                    <span class="risk-company-content" v-for="(item, index) in scope.row.riskCompany" :key="index">
                      <span style="display:inline-block;">
                        {{item.deptName}}({{item.name}});
                      </span>
                    </span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="150" prop="statusVal"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="btn-text"
                  @click="lookDetails(scope.row.id)"
                  >详情</el-button
                >
                <el-button
                  v-if="scope.row.status != 'COMPLETED' && scope.row.status != 'REVOKED'"
                  type="text"
                  class="btn-text-red"
                  @click="revoke(scope.row.id)"
                  >撤销</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
      
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import { formatTimeToDate } from "@/common/js/utils.js"
import { statusMixins } from '@/common/mixins/status/status.js'
import Risk from "@/models/risk.js";
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      ruleForm: {
        taskName: '',
        date: '',
        status: '',
        executor: ''
      },
      statusList: [
        {
          id:'TO_BE_CHECKED',
          name: '待检查'
        },
        {
          id:'TO_BE_CONFIRMED',
          name: '待确认'
        },
        {
          id:'TO_BE_RECTIFIED',
          name: '待整改'
        },
        {
          id:'TO_BE_CLEARED',
          name: '待清除'
        },
        {
          id:'COMPLETED',
          name: '已完成'
        },
        {
          id:'REVOKED',
          name: '已撤销'
        },
      ],
      isShowTooltip: false,
      isShowTableTooltip: true
    }
  },

  created() {
    config()
    this.initTableList()
  },

  methods: {
    onMouseOver(str,length, type, arr) {
      let itemFontSize = 14
      let contentWidth = this.$refs[str].offsetWidth;
      if (type !== 'refExecutorTooltip') {
        let textAllWidth
        if (type == 'refRiskCompanyrTooltip') {
          let nums = 0
          arr.map(i => {
            let newStr = `${i.deptName}(${i.name});`
            nums += newStr.length
          })
          textAllWidth = (nums*itemFontSize) - contentWidth*2
        } else {
          textAllWidth = (length*itemFontSize) - contentWidth*2
        }
        // 判断是否开启tooltip功能
        if (textAllWidth > 0) {
          this.isShowTooltip = true;
        } else {
          this.isShowTooltip = false;
        }
      } else {
        if (length>4) {
          this.isShowTooltip = true;
        } else {
          this.isShowTooltip = false;
        }
      }
    },

    onMouseOverTable(str) {
      const tag = this.$refs[str]
      // 获取父级元素的可视高度
      const parentHeight = tag.parentNode.offsetHeight
      // 获取元素的可视高度
      const contentHieght = tag.offsetHeight
      this.isShowTableTooltip = contentHieght <= parentHeight
    },

    initTableList() {
      let data = {}
      data.taskName = this.ruleForm.taskName
      data.status = this.ruleForm.status
      data.leftPublishTime = this.ruleForm.date ? this.ruleForm.date[0] : ''
      data.rightPublishTime = this.ruleForm.date ? this.ruleForm.date[1] : ''
      data.implementName = this.ruleForm.executor
      data.pageNo = this.currentPage
      Risk.getRiskReleaseList(data).then(res => {
        if (res.success) {
          let arr = []
          this.totalNum = res.result.totalNum
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.taskName = i.taskName
            obj.createTime = i.publishTime ? formatTimeToDate(i.publishTime) : ''
            obj.status = i.status
            obj.statusVal = this.RISK_RELEASE_STATUS[i.status]
            obj.executor = []
            i.riskImplementEntityList.map(v => {
              let executorObj = {}
              executorObj.name = v.userName
              executorObj.deptName = v.deptName
              obj.executor.push(executorObj)
            })
            obj.director = []
            // i.riskResponsibilityEntity.map(v => {
              let directorObj = {}
              directorObj.name = i.riskResponsibilityEntity.userName
              directorObj.deptName = i.riskResponsibilityEntity.deptName
              obj.director.push(directorObj)
            // })
            obj.riskCompany = []
            i.riskMainUnitEntityList.map(v => {
              let riskCompanyObj = {}
              riskCompanyObj.name = v.userName
              riskCompanyObj.deptName = v.deptName
              obj.riskCompany.push(riskCompanyObj)
            })
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initTableList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    toRelease() {
      this.$router.push({
        path: '/oneLevel/riskModuleIndex/riskReleaseIndex/riskReleaseWarn',
      })
    },

    lookDetails(id) {
      this.$router.push({
        path: '/oneLevel/riskModuleIndex/riskReleaseIndex/riskReleaseDetails',
        query: {
          id: id
        }
      })
    },

    revoke(id) {
      this.$confirm("任务撤销后不可恢复，是否继续？", "确认撤销任务", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        this.revokeTask(id)
      });
    },

    revokeTask(id) {
      let data = {
        id
      }
      Risk.postRevokeTask(data).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "撤销成功",
          });
          this.initTableList()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.purchase {
  flex: 1;
  background: $bg-WhiteSmoke;
  .purchase-container {
    height: 100%;
  }
  .top-container {
    box-sizing: border-box;
    background: $bg-white;
    padding: 10px;
    .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin-bottom: 10px
    }
    .el-input__prefix, .el-input__suffix {
      top: -3px;
    }
    .row {
      @include flex-start;
      flex-wrap: wrap;
      .btn {
        margin-left: 30px;
        margin-bottom: 7px;
        .el-form-item__content {
          margin-left: 0px!important;
          display: flex;
        }
        .btn-blue {
          @include flex-center;
        }
      }
    }
  }
  .container {
    flex: 1;
    min-height: 727px;
    margin-top: 20px;
    padding: 20px;
    box-sizing: border-box;
    background: $bg-white;
    .table-billCode {
      color: $color-DeepReddishBlue;
    }
    .table-status {
      @include flex-start;
      .spot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 6px;
      }
      .red {
        background: $bg-Crimson;
      }
      .blue {
        background: $bg-DeepReddishBlue;
      }
      .green {
        background: $bg-LawnGreen;
      }
      .spot-gray {
        background: $bg-SpotGray;
      }
    }
    .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: auto;
      line-height: 22px;
      @include two-wrap-ellipsis();
    }
    .risk-company {
      background: #F5F6F7;
      border-radius: 6px;
      padding: 3px 10px;
    }
  }
  
  .nothing {
    position: absolute;
    left: 52%;
    top: 50%;
    transform: translate(-50%,-50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
}
</style>

